{
  "A person's follow-up is open to that person, their coach and the DAR.": "Le suivi d'une personne est ouvert à cette personne, à son coach et à la DAR.",
  "Absent / no activity": "Absent / pas d'activité",
  "Activity reports": "Comptes rendus",
  "Allocation in {{year}}": "Attribution en {{year}}",
  "Assigned / working days": "Jours affectés / ouvrés",
  "Assignments": "Affectations",
  "Awaiting the DAR": "En attente de la DAR",
  "Boond names nobody with you as their HR manager.": "Boond ne désigne personne dont vous êtes le manager RH.",
  "By the DAR": "Par la DAR",
  "Coach: {{name}}": "Coach : {{name}}",
  "Current projects": "Projets en cours",
  "Date": "Date",
  "Decision": "Décision",
  "Departed": "Parti",
  "Effective date: {{date}}": "Date d'effet : {{date}}",
  "Follow-up": "Suivi",
  "Job title": "Intitulé",
  "Loading the follow-up…": "Chargement du suivi…",
  "Loading your team…": "Chargement de votre équipe…",
  "Missing": "Manquant",
  "My space": "Mon espace",
  "My team": "Mon équipe",
  "My year": "Mon année",
  "No activity report in {{year}}": "Aucun compte rendu en {{year}}",
  "No assignment in {{year}}.": "Aucune affectation en {{year}}.",
  "No coach in Boond": "Pas de coach dans Boond",
  "No current project": "Aucun projet en cours",
  "No report filed for this week.": "Aucun compte rendu déposé pour cette semaine.",
  "No request in {{year}}.": "Aucune demande en {{year}}.",
  "Nobody to coach": "Personne à suivre",
  "Not filled in": "Non renseigné",
  "On request": "Sur demande",
  "Origin": "Origine",
  "Period": "Période",
  "Person": "Personne",
  "Person not found": "Personne introuvable",
  "Project": "Projet",
  "Request": "Demande",
  "Requests": "Demandes",
  "Restricted follow-up": "Suivi réservé",
  "Share of the month's working days:": "Part des jours ouvrés du mois :",
  "Status": "Statut",
  "Stream": "Stream",
  "Stream “{{stream}}”": "Stream « {{stream}} »",
  "The people you coach (HR manager in Boond): open one to follow their year, assignments and reports.": "Les personnes que vous coachez (manager RH dans Boond) : ouvrez-en une pour suivre son année, ses affectations et ses comptes rendus.",
  "Total": "Total",
  "Whole project": "Tout le projet",
  "Working days assigned per project and month in {{year}}. The darker the cell, the larger the share of the month's working days; months to come (in italics) show the planned allocation.": "Jours ouvrés affectés par projet et par mois en {{year}}. Plus la case est foncée, plus la part des jours ouvrés du mois est grande ; les mois à venir (en italique) montrent l'attribution prévue.",
  "Year": "Année",
  "from {{date}}": "à partir du {{date}}",
  "since {{date}}": "depuis le {{date}}",
  "{{assigned}} of {{working}} working days assigned ({{percent}})": "{{assigned}} jours ouvrés affectés sur {{working}} ({{percent}})",
  "{{count}} missing reports_one": "{{count}} compte rendu manquant",
  "{{count}} missing reports_other": "{{count}} comptes rendus manquants",
  "{{count}} reports_one": "{{count}} compte rendu",
  "{{count}} reports_other": "{{count}} comptes rendus"
}
